
let events = [
    {
        "time": "June 26, 2021",
        "event": "Our research paper entitled \"An Ultrastable Aqueous Iodine-Hydrogen Gas Battery\" was published in Advanced Functional Materials. Congratulations to Zhengxin!"
    },
    {
        "time": "June 26, 2021",
        "event": "Prof. Wei Chen gave an invited talk at University of South China, Hunan."
    },
    {
        "time": "June 2, 2021",
        "event": "Congratulations to Dr. Yan Xu for getting Chinese Postdoc Science Foundation!"
    },
    {
        "time": "May 27, 2021",
        "event": "Prof. Wei Chen gave an invited talk at Shandong University."
    },
    {
        "time": "May 26, 2021",
        "event": "Prof. Wei Chen gave an invited talk at University of Jinan, Shandong."
    },
    {
        "time": "April 27, 2021",
        "event": "Prof. Wei Chen gave an invited talk at Hunan University, Changsha."
    },
    {
        "time": "April 26, 2021",
        "event": "Prof. Wei Chen gave an invited speech at his alma mater Yueyang No. 13 middle school. He was awarded as a Distinguished Alumni and Honorary President of Yueyang No. 13 middle school, Yueyang city, Hunan Province."
    },
    {
        "time": "April 23, 2021",
        "event": "The Chen group had a joyful spring tour in Huiyuan Garden, Hefei."
    },
    {
        "time": "January 23, 2021",
        "event": "The Chen group had a happy end-of-the-year dinner in the city of Hefei!"
    },
    {
        "time": "January 6, 2021",
        "event": "Our review entitled \"Recent Progress in High-Entropy Alloys for Catalysts: Synthesis, Applications, and Prospects\"was published in Materials Today Energy. Congratulations to Ke!\n"
    },
    {
        "time": "December 21, 2020",
        "event": "Our invited review entitled \"Opportunities of Aqueous Manganese-Based Batteries with Deposition and Stripping Chemistry\"was published in Advanced Energy Materials. Congratulations to Mingming!\n"
    },
    {
        "time": "December 9, 2020",
        "event": "Our invited paper entitled \"A high performance aqueous iron-hydrogen gas battery\"was published in Materials Today Energy. Congratulations to Zhengxin!\n"
    },
    {
        "time": "October 23, 2020",
        "event": "The Chen group enjoyed a wonderful trip to Mushan Island in Chaohu Lake, Hefei!"
    },
    {
        "time": "October 20, 2020",
        "event": "Welcome postdocs Dr. Jifei Sun and Dr. Yan Xu to join our group!"
    },
    {
        "time": "September 25, 2020",
        "event": "Welcome international Master student Sunhyeong Park to join our group!"
    },
    {
        "time": "September 20, 2020",
        "event": "Welcome postdocs Dr. Mingyan Chuai, Dr. Yuan Yuan and Dr. Zaichun Liu to join our group!"
    },
    {
        "time": "September 8, 2020",
        "event": "Welcome PhD students Taoli Jiang, Xinhua Zheng and Master students Yahan Meng, Na Chen, Chunyue Shen to join our group!"
    },
    {
        "time": "July 31, 2020",
        "event": "Our invited paper entitled \"Lithium Intercalation Compounds-Hydrogen Gas Batteries\"was published in Chemical Journal of Chinese Universities. Good job, Zhengxin!"
    },
    {
        "time": "July 16, 2020",
        "event": "Welcome Dr. Ke Li to join our group as a postdoc!"
    },
    {
        "time": "April 17, 2020",
        "event": "Our first paper entitled \"A High-Rate Lithium Manganese Oxide-Hydrogen Battery\"was published in Nano Letters. Good job, Zhengxin!"
    },
    {
        "time": "January 4, 2020",
        "event": "Prof. Wei Chen attended the 1st young scholar forum hosted by Cailiaoren and gave an invited talk in Beijing."
    },
    {
        "time": "December 1-6, 2019",
        "event": "Prof. Wei Chen attended 2019 MRS Fall meeting at Boston, Massachusetts and gave a talk on \"Rechargeable Hydrogen Batteries for Grid Scale Energy Storage\"."
    },
    {
        "time": "November 16-19, 2019",
        "event": "Zhengxin Zhu and Mingming Wang attended the conference of \"Next-generation materials for energy applications\"in Xiamen University."
    },
    {
        "time": "October 21, 2019",
        "event": "Prof. Wei Chen gave an invited talk at the Shanghai Tech University."
    },
    {
        "time": "October 20, 2019",
        "event": "Prof. Wei Chen gave an invited talk at the East China Normal University."
    },
    {
        "time": "September 8, 2019",
        "event": "Chen Research Group website is launched!"
    },
    {
        "time": "August 20, 2019",
        "event": "Welcome undergraduate student Haosong Jiang to join our group!"
    },
    {
        "time": "August 14-16, 2019",
        "event": "Prof. Wei Chen attended the 5th International Conferenceon Energy Conversion and Storage at Peking University."
    },
    {
        "time": "July 24, 2019",
        "event": "Prof. Wei Chen gave an invited talk at the Hunan Institute of Science and Technology on Rechargeable Hydrogen Batteries for Grid Scale Energy Storage."
    },
    {
        "time": "July 17, 2019",
        "event": "Welcome Master student Mingming Wang to join our group!"
    },
    {
        "time": "July 11, 2019",
        "event": "Welcome PhD student Zhengxin Zhu to join our group!"
    },
    {
        "time": "July 8, 2019",
        "event": "Prof. Wei Chen started his research group at USTC!"
    }
]
export default events;